<template>
    <ul v-if="data">
        <li class="data-block-number">
            <p class="data-label">{{ $l10n.__("Sur l'exercice fiscal") }}</p>
            <h3 class="data-value">
                {{
                    $filters.numberFormatWithOptions(
                        data.year,
                        { currencysymbol: currencySymbol },
                        true,
                    )
                }}
            </h3>
            <number-diff
                :tooltipText="
                    $t.__('dashboard.cards.TemplateTurnoverCard.compare_to_previous_year')
                "
                :amount="data.year"
                :comparison="data.lastYear"
                :currencySymbol="currencySymbol"
            />
        </li>
        <li class="data-block-number">
            <p class="data-label">{{ $l10n.__('Ce mois') }}</p>
            <h3 class="data-value">
                {{
                    $filters.numberFormatWithOptions(
                        data.month,
                        { currencysymbol: currencySymbol },
                        true,
                    )
                }}
            </h3>
            <number-diff
                :tooltipText="
                    $t.__('dashboard.cards.TemplateTurnoverCard.compare_to_previous_month')
                "
                :amount="data.month"
                :comparison="data.lastMonth"
                :currencySymbol="currencySymbol"
            />
        </li>
        <li class="data-block-number">
            <p class="data-label">{{ $l10n.__("Aujourd'hui") }}</p>
            <h3 class="data-value">
                {{
                    $filters.numberFormatWithOptions(
                        data.day,
                        { currencysymbol: currencySymbol },
                        true,
                    )
                }}
            </h3>
        </li>
    </ul>
</template>

<script>
import NumberDiff from '../../utilities/NumbersDiff.vue';
export default {
    components: {
        NumberDiff,
    },
    props: {
        data: {
            type: Object,
        },
        currencySymbol: {
            type: String,
            required: false,
        },
    },
};
</script>

<style lang="scss">
@use '~@sellsy/styleguide/src/_variables' as *;

.card-turnover {
    text-align: center;

    .data-block-number {
        margin-bottom: var(--spacing-5);

        h3 {
            font-size: $extra-big-font-size;
        }
    }

    .card-body {
        align-items: center;
        justify-content: center;
    }
}
</style>
